import { sorting, storePagination } from '@/mixins'
import { clearFormatting } from '@/utils/cnpj-alphanumeric'
import axios from '@axios'

const getInitialState = () => ({
  ...storePagination.state(),
  customers: [],
  filter: {
    id: null,
    document: '',
    name: '',
  },
  queryExecuted: false,
})

export default {
  namespaced: true,

  state: getInitialState(),

  mutations: {
    ...storePagination.mutations,

    SET_CUSTOMERS(state, customers) {
      state.customers = customers
    },
    SET_FILTER(state, filter) {
      state.filter = filter
    },
    SET_QUERY_EXECUTED(state, queryExecuted) {
      state.queryExecuted = queryExecuted
    },
    UPDATE_CUSTOMER_EMAIL_ACCESS(state, { id, emailAccess }) {
      const customer = state.customers.find(item => item.id === id)
      if (customer) customer.emailAccess = emailAccess
    },
    CLEAN_STATE(state) {
      const { filter, paging, customers } = getInitialState()
      state.filter = filter
      state.customers = customers
      state.paging = paging
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchCustomers({ state, commit }) {
      const { id, document, name } = state.filter

      const { data } = await axios.get('/api/customers/email-access', {
        params: {
          id,
          document: clearFormatting(document) || '',
          name: name || '',
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_CUSTOMERS', data.results)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount,
        rowsInCurrentPage: data.rowsInCurrentPage,
      })
      commit('SET_QUERY_EXECUTED', true)
    },

    async updateEmailAccess({ commit }, { id, emailAccess }) {
      const { data } = await axios.patch(`/api/customers/${id}/email-access`, {
        emailAccess,
      })

      // Atualiza a linha da listagem com o novo valor retornado pela API somente
      // após o sucesso da persistência (conflito/falha não commitam nada).
      commit('UPDATE_CUSTOMER_EMAIL_ACCESS', {
        id,
        emailAccess: data?.emailAccess ?? emailAccess,
      })

      return data
    },

    setFilter({ commit }, filter) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTER', filter)
    },

    resetFilter({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTER', getInitialState().filter)
      commit('CLEAN_STATE')
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
